import {
  getLedger,
  getLedgerWithSettings,
  getLedgerSettings,
} from '../../api/api'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import { addScheduledCharges } from './scheduledCharges'
import getProjectName from 'portal-modules/common/utils/get-project-name'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isNotRP } = getProjectConditions()


// action types
const REQUEST_PAGINATED_LEDGER = 'rp/ledger/REQUEST_PAGINATED_LEDGER'
const REQUEST_LEDGER = 'rp/ledger/REQUEST_LEDGER'
const RECEIVE_LEDGER = 'rp/ledger/RECEIVE_LEDGER'
const RESET_LEDGER = 'rp/ledger/RESET_LEDGER'
const REQUEST_LEDGER_SETTINGS = 'rp/ledger/REQUEST_LEDGER_SETTINGS'
const UPDATE_LEDGER = 'rp/ledger/UPDATE_LEDGER'
const SAVE_LEDGER = 'rp/ledger/SAVE_LEDGER'

// reducer
export default function ledger(state = {}, { type, payload }) {
  switch (type) {
    case SAVE_LEDGER:
      return { ...state, ...payload }
    case RECEIVE_LEDGER:
      return [...Object.values(state), ...Object.values(payload)]
    case CHANGE_USER_ACCOUNT:
    case RESET_LEDGER:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestLedger = () => ({ type: REQUEST_LEDGER })
export const requestPaginatedLedger = payload => ({
  type: REQUEST_PAGINATED_LEDGER,
  payload,
})
export const resetLedger = () => ({ type: RESET_LEDGER })
export const updateLedger = payload => ({ type: UPDATE_LEDGER, payload })
export const requestLedgerSettings = () => ({ type: REQUEST_LEDGER_SETTINGS })

// sagas
function* fetchLedger() {
  yield delay(1000)
  const { ledger, scheduled_charges = {}, settings } = yield call(
    getLedgerWithSettings,
  )
  if ((isNotRP || settings?.display_ledger_by == 'Invoices') && ledger) {
    yield put({
      type: RECEIVE_LEDGER,
      payload: ledger,
    })
  }
  if (getProjectName() != 'rh' && scheduled_charges)
    yield put(addScheduledCharges(scheduled_charges))
  if (settings) yield put(addSettings({ ledger: settings }))
}

function* fetchPaginatedLedger({ payload }) {
  const { ledger } = yield call(getLedger, {
    page: payload.page,
    items_per_page: payload.items,
  })
  let ledgerTransactionLength = 0
  if (ledger) {
    yield put({
      type: RECEIVE_LEDGER,
      payload: ledger,
    })
    ledgerTransactionLength = ledger?.length
  }

  if (typeof payload.callback === 'function') {
    yield call(payload.callback, ledgerTransactionLength)
  }
}

function* watchRequestLedger() {
  yield takeLatest(
    REQUEST_LEDGER,
    createRequestSaga(fetchLedger, {
      key: 'payments',
      message: __('Looking for transactions'),
    }),
  )
}

function* watchRequestPaginatedLedger() {
  yield takeLatest(
    REQUEST_PAGINATED_LEDGER,
    createRequestSaga(fetchPaginatedLedger, {
      key: 'payments',
      message: __('Looking for transactions'),
    }),
  )
}

function* fetchLedgerSettings() {
  const { settings } = yield call(getLedgerSettings)
  if (settings) yield put(addSettings({ ledger: settings }))
}

function* watchRequestLedgerSettings() {
  yield takeLatest(
    REQUEST_LEDGER_SETTINGS,
    createRequestSaga(fetchLedgerSettings, {
      key: 'payments',
      message: __('Looking for transactions'),
    }),
  )
}

function* fetchAndUpdateLedger({ payload }) {
  let { ledger: oldLedger } = yield select()
  let newLedger = {}
  let newKey = 0
  newLedger[newKey] = { ...payload }
  if (Object.values(oldLedger).length == 0) {
    let { ledger } = yield call(getLedger)
    oldLedger = ledger
  }

  for (var key in oldLedger) {
    newKey = parseInt(key) + 1
    newLedger[newKey] = oldLedger[key]
  }

  yield put({
    type: SAVE_LEDGER,
    payload: newLedger,
  })
}

function* watchReceiveLedger() {
  yield takeLatest(
    UPDATE_LEDGER,
    createRequestSaga(fetchAndUpdateLedger, {
      key: 'payments',
      message: __('Looking for transactions'),
    }),
  )
}

export const sagas = [
  watchRequestLedger,
  watchRequestLedgerSettings,
  watchReceiveLedger,
  watchRequestPaginatedLedger,
]
